export default "__VITE_ASSET__$BMw4MB4__"